import type { FaireProductEntity } from "../../entity_types/product";

export const p_397gdetwca: FaireProductEntity = {
  token: "p_397gdetwca",
  type: "product",
  name: "Flower Patch Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7cfaba239fde24e34e33a6a6e25d9d47f53e6b45265aebeed9cd44dba4562a82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/510040aaae1289ec8b442c5fc035e96a180177c21ce670c3d6757916c05d8bd6.jpeg",
    "https://cdn.faire.com/fastly/4bcc81cbcbecc3f684905b5cba0623200c99d9e610c07409662ed6198bee4e08.jpeg",
    "https://cdn.faire.com/fastly/a1ab4672203c17bf6b213c76ee368eef209f82dafa37426b94ef5ece54bc1905.webp",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:25.482Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
